import type * as Types from 'app/types/graphql';

import { HeatmapScrollRowSelectFragmentDoc } from '../fragments/heatmapScrollRow.generated';
import { useQuery, type UseQueryOptions } from '@tanstack/react-query';
import { appFetcher } from '~/api/utils/gatewayClient';
export type HeatmapScrollQueryVariables = Types.Exact<{
  where: Types.HeatmapScrollWhereInput;
}>;

export type HeatmapScrollQueryResponse = {
  heatmapScroll?: Types.Maybe<
    Pick<
      Types.HeatmapScrollData,
      | 'totalSessions'
      | 'avgScrollDepth'
      | 'averageFold'
      | 'totalOrders'
      | 'totalRevenue'
      | 'totalTimeOnPage'
      | 'totalVisitors'
    > & {
      rows: Array<
        Pick<
          Types.HeatmapScrollRow,
          | 'scrollReachPercent'
          | 'visitors'
          | 'percUsers'
          | 'dropOffPercent'
          | 'dwellTimeMs'
          | 'avgDwellTimeMs'
          | 'convertedSessions'
          | 'convertedVisitors'
          | 'orders'
          | 'revenue'
        >
      >;
    }
  >;
};

export const HeatmapScrollDocument = `
    query HeatmapScroll($where: HeatmapScrollWhereInput!) {
  heatmapScroll(where: $where) {
    rows {
      ...HeatmapScrollRowSelect
    }
    totalSessions
    avgScrollDepth
    averageFold
    totalOrders
    totalRevenue
    totalTimeOnPage
    totalVisitors
  }
}
    ${HeatmapScrollRowSelectFragmentDoc}`;

export const useHeatmapScrollQuery = <TData = HeatmapScrollQueryResponse, TError = unknown>(
  variables: HeatmapScrollQueryVariables,
  options?: UseQueryOptions<HeatmapScrollQueryResponse, TError, TData>,
) => {
  return useQuery<HeatmapScrollQueryResponse, TError, TData>(
    ['HeatmapScroll', variables],
    appFetcher<HeatmapScrollQueryResponse, HeatmapScrollQueryVariables>(
      HeatmapScrollDocument,
      variables,
    ),
    options,
  );
};

useHeatmapScrollQuery.getKey = (variables: HeatmapScrollQueryVariables) => [
  'HeatmapScroll',
  variables,
];
